exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".title[data-v-40decce7] {\n  font-size: 20px;\n}\n.noteText[data-v-40decce7] {\n  margin-bottom: 10px;\n  resize: none;\n}\n.modal-content[data-v-40decce7] {\n  width: 440px !important;\n  margin-top: 12%;\n}\n", ""]);
